import { captureException } from '../../../utils/sentry';

/** This function requires a secure connection (e.g. https),
 * so it may not work properly when developing locally. */
export async function copy(copyText: string) {
  const text = String(copyText ?? '');

  if (navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // fall through — click activation may already be spent (after await)
    }
  }

  try {
    copyWithExecCommand(text);
  } catch (error) {
    captureException('Failed to write text to clipboard.', error, {
      feature: 'clipboard-copy',
      source: 'eds.utils.copy',
    });
    throw error;
  }
}

/** Fallback copy function using execCommand if clipboard API is unavailable.
 * execCommand is deprecated but often still supported as a fallback. */
function copyWithExecCommand(text: string) {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  try {
    el.select();
    el.setSelectionRange(0, text.length);
    if (!document.execCommand('copy')) {
      throw new Error('execCommand copy failed');
    }
  } finally {
    el.remove();
  }
}
